import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../design-system/icons.jsx';
import { copyToClipboard } from '../utils/clipboard';

export default function CopyCell({ value, display, children, style }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleCopy = useCallback((e) => {
    e.stopPropagation();
    copyToClipboard(String(value ?? ''));
    setCopied(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setCopied(false), 1500);
  }, [value]);

  return (
    <span className="copy-cell" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, ...style }}>
      {children ?? display ?? value}
      <button
        type="button"
        onClick={handleCopy}
        title={t(copied ? 'common.copied' : 'common.copy')}
        aria-label={t(copied ? 'common.copied' : 'common.copy')}
        className="copy-cell-btn"
        style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 16, height: 16, borderRadius: 3, flexShrink: 0,
          background: 'transparent', border: 'none', cursor: 'pointer', padding: 0,
          color: copied ? 'var(--success)' : 'var(--text-muted)',
          opacity: 0, transition: 'opacity var(--dur-fast), color var(--dur-fast)',
        }}
      >
        {copied
          ? <Icon name="check" size={11} strokeWidth={2.5} />
          : <Icon name="copy" size={11} strokeWidth={2} />
        }
      </button>
    </span>
  );
}
